// extracted by mini-css-extract-plugin
export var copyableField = "_sg-4";
export var customerBadge = "_sg-0";
export var customerInfoTitle = "_sg-2";
export var details = "_sg-1";
export var dropdownContainer = "_sg-5";
export var dropdownImage = "_sg-6";
export var editAssigneeForm = "_sg-a";
export var editButton = "_sg-3";
export var email = "_sg-7";
export var hidden = "_sg-d";
export var input = "_sg-8";
export var saveButton = "_sg-b";
export var shopifyIcon = "_sg-c";
export var suggestionBadge = "_sg-e";
export var suggestionText = "_sg-f";
export var username = "_sg-9";